/**
 * @module option responses
 */
import { createReducer } from '@reduxjs/toolkit';
import { reportingActions } from '~/behaviors/actions/reporting.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

const mergeOptionResponses = (state, action) => {
  const optionResponses = action?.payload?.entities?.optionResponses || {};

  Object.values(optionResponses).forEach((optionResponse) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    state[optionResponse.id] = {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      ...state[optionResponse.id],
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...optionResponse,
    };
  });
};

const questionReports = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);
  builder.addCase(reportingActions.fetchQuestionResults.fulfilled, mergeOptionResponses);

  builder.addCase(reportingActions.fetchQuestionAttributeResponses.fulfilled, mergeOptionResponses);
});

export default questionReports;
